var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('span',{staticClass:"column"},[_vm._v(_vm._s(_vm.tagName))]),_c('span',{staticClass:"column"},[_c('router-link',{attrs:{"to":{ path: '/edit-category/' + _vm.category.id}}},[_vm._v("Edit")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }